import { DomainError } from './DomainError';
import type { SubscriptionId } from '~/composables/mercure';

export class SubscriptionError extends DomainError {
  constructor (
    message: string,
    subscriptionId?: SubscriptionId,
    context?: Record<string, unknown>,
  ) {
    super(
      message,
      'SUBSCRIPTION_ERROR',
      { subscriptionId, ...context },
    );

    Object.setPrototypeOf(this, SubscriptionError.prototype);
  }
}
